import { useQuery } from '@apollo/client';
import { graphql } from '@gql/gql';
import type { BreederGetReviewsQuery, BreederGetReviewsQueryVariables } from '@gql/graphql';
import { useMemo } from 'react';

export const BREEDER_GET_REVIEWS = graphql(`
  query BreederGetReviews($where: DogBreederReviewWhereInput) {
    aggregateDogBreederReview(where: $where) {
      _count {
        _all
      }
      _avg {
        humanContactGrade
        hygieneGrade
        globalGrade
        dogsWellBeingGrade
        followUpGrade
      }
    }
  }
`);

export const useGetReviews = (breederId?: number) => {
  const variables: BreederGetReviewsQueryVariables = useMemo(() => {
    return {
      where: {
        dogBreederId: { equals: breederId },
      },
    } as BreederGetReviewsQueryVariables;
  }, [breederId]);

  const { data, error, loading, refetch } = useQuery<
    BreederGetReviewsQuery,
    BreederGetReviewsQueryVariables
  >(BREEDER_GET_REVIEWS, {
    variables,
    skip: breederId == null,
    ssr: false,
  });
  return {
    breederReviewsAggregate: data?.aggregateDogBreederReview,
    breederReviewsError: error,
    breederReviewsLoading: loading,
    breederReviewsVariables: variables,
    breederReviewsRefetch: refetch,
  };
};
